import { FC, ReactNode } from 'react';
import { UserLimits } from '@robocorp/robocloud-internal-cds-sdk';
import { useSelector } from '~/hooks';

interface Props {
  permission: Exclude<keyof UserLimits, 'maxAccessCredentials' | 'maxOrganizations'>;
  children: ReactNode;
}

/**
 * Renders child component if current user have requested permissions
 */
export const CurrentUserRestriction: FC<Props> = ({ children, permission }) => {
  const limitOverrides = useSelector(
    ({ userResources }) => userResources.users.current?.limit_overrides,
  );
  return limitOverrides?.[permission] ? <>{children}</> : null;
};
